// import React from 'react';

// const AdminPage = () => {
//   // const [users, setUsers] = useState([]);
//   // const [shops, setShops] = useState([]);

//   // useEffect(() => {
//   //   const fetchData = async () => {
//   //     try {
//   //       const usersRes = await api.get('/admin/users');
//   //       const shopsRes = await api.get('/admin/shops');
//   //       setUsers(usersRes.data);
//   //       setShops(shopsRes.data);
//   //     } catch (err) {
//   //       console.error(err);
//   //     }
//   //   };
//   //   fetchData();
//   // }, []);

//   return (
//     <div>
//       <h1 className="text-3xl font-bold mb-4">Panel Administratora</h1>
      
//       <div className="mb-8">
//         <h2 className="text-2xl font-bold mb-2">Użytkownicy</h2>
//         {/* User management UI */}
//       </div>

//       <div>
//         <h2 className="text-2xl font-bold mb-2">Sklepy</h2>
//         {/* Shop management UI */}
//       </div>
//     </div>
//   );
// };

// export default AdminPage;

import React, { useEffect, useState } from "react";
import api from "../services/api";

const safeText = (val) => {
  if (val === null || val === undefined) return "";
  if (typeof val === "string" || typeof val === "number" || typeof val === "boolean") return String(val);
  if (typeof val === "object") {
    if (val.email) return val.email;
    if (val._id) return String(val._id);
    if (val.id) return String(val.id);
    try {
      const s = JSON.stringify(val);
      return s.length > 120 ? s.slice(0, 117) + "..." : s;
    } catch {
      return "[object]";
    }
  }
  return String(val);
};

const AdminPage = () => {
  const [users, setUsers] = useState([]);
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [restartStatus, setRestartStatus] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const usersRes = await api.get("/admin/users");
      const shopsRes = await api.get("/admin/shops");

      const u = Array.isArray(usersRes.data) ? usersRes.data : usersRes.data?.users || [];
      const s = Array.isArray(shopsRes.data) ? shopsRes.data : shopsRes.data?.shops || [];

      setUsers(u);
      setShops(s);
    } catch (err) {
      console.error("fetchData error:", err);
      setError("Nie udało się pobrać danych.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // // debug
  // useEffect(() => {
  //   console.log("USERS:", users);
  // }, [users]);
  // useEffect(() => {
  //   console.log("SHOPS:", shops);
  // }, [shops]);

  const getKey = (item) => {
    return item?._id ?? item?.id ?? `${Math.random().toString(36).slice(2,9)}`;
  };
  
  const handleRestart = async () => {
    setRestartStatus("pending");
    try {
      const res = await api.post("/restart");
      setRestartStatus(res.data?.message || "Restart requested.");
    } catch (err) {
      setRestartStatus("Błąd restartu serwera.");
    }
  };
  if (loading) return <p>Ładowanie…</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div>
      <h1 className="text-3xl font-bold mb-4">Panel Administratora</h1>

      {/* SYSTEM RESTART BUTTON */}
      <button
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
          onClick={handleRestart}
          disabled={restartStatus === "pending"}
        >
          {restartStatus === "pending" ? "Restartowanie..." : "Restartuj system"}
        </button>
        {restartStatus && restartStatus !== "pending" && (
          <p className="mt-2 text-sm text-gray-700">{restartStatus}</p>
        )}

      {/* UŻYTKOWNICY */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-2">Użytkownicy</h2>

        {users.length === 0 ? (
          <p>Brak użytkowników.</p>
        ) : (
          <ul className="space-y-2">
            {users.map((u, idx) => {
              const key = getKey(u) + "-user-" + idx;
              return (
                <li
                  key={key}
                  className="p-3 bg-gray-100 text-black rounded flex justify-between items-center"
                >
                  <div>
                    <p><strong>ID:</strong> {safeText(u._id ?? u.id)}</p>
                    <p><strong>Email:</strong> {safeText(u.email)}</p>
                    <p><strong>Rola:</strong> {safeText(u.role)}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>

      {/* SKLEPY */}
      <div>
        <h2 className="text-2xl font-bold mb-2">Sklepy</h2>

        {shops.length === 0 ? (
          <p>Brak sklepów.</p>
        ) : (
          <ul className="space-y-2">
            {shops.map((s, idx) => {
              const key = getKey(s) + "-shop-" + idx;
              return (
                <li
                  key={key}
                  className="p-3 bg-gray-100 text-black rounded flex justify-between items-center"
                >
                  <div>
                    <p><strong>ID:</strong> {safeText(s._id ?? s.id)}</p>
                    <p><strong>Nazwa:</strong> {safeText(s.name)}</p>
                    <p><strong>Właściciel:</strong> {safeText(s.owner)}</p>

                    {/* <pre className="text-xs">{JSON.stringify(s, null, 2)}</pre> */}
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default AdminPage;
